import { useEffect, useState,useRef } from "react";
import useSWR from "swr";
/* import { Form } from "react-bootstrap";*/
import DatePicker from "react-datepicker";
import {
  entities as getEntities,
  languages as getLanguages,
  search,
} from "../api/api";
import { ContactTable } from "../components/ContactTable";
import { useDangerAlert } from "../hooks/useAlert";
import { MultiSelect } from "../components/MultiSelect";
import { Select } from "../components/Select";
import { ContentLayout } from "@cloudscape-design/components";
import { Button, Link, Header, Form, Grid, Container, SpaceBetween, Input, FormField, TextContent } from '@cloudscape-design/components';

let err100text="";

const sentimentWhat = [
  { value: "average", label: "Average" },
  { value: "trend", label: "Trending" },
];

const sentimentWho = [
  { value: "caller", label: "Customer" },
  { value: "agent", label: "Agent" },
];

const sentimentDirection = [
  { value: "positive", label: "Positive" },
  { value: "negative", label: "Negative" },
];

function Search({ setAlert }) {
  const [editing, setEditing] = useState(true);
  const [query, setQuery] = useState({});
  const [shouldSearch, setShouldSearch] = useState(true);

  useEffect(() => {
    (query.timestampTo && query.timestampTo) ||
    (!query.timestampTo && !query.timestampFrom)
      ? setShouldSearch(true)
      : setShouldSearch(false);
  }, [query.timestampTo, query.timestampFrom]);

  const { data: entities, error: errorEntities } = useSWR(
    `/entities`,
    getEntities
  );
  const { data: languageCodes, error: errorLanguageCodes } = useSWR(
    `/languages`,
    getLanguages
  );
  const { data: results, error: errorResults } = useSWR(
    shouldSearch ? [`/search`, query] : null,
    () => search(query)
  );

  try
  {
    console.log(results)
    if(results!=[] && results &&results!=null)
    {
      console.log('HELLO WORLD RESULT '+results.length)
      if(results.length>1000)
       
      {
        err100text=`Please refine your search [${results.length}], on Date Range (From and To), note only max 1000 records can be displayed`;
      }
      else err100text="";
      /*
      for(let i=0; i<results.length;i++)
      { 
        console.log(results[i].jobName + " " + results[i].Agent + " "+ new Date(results[i].timestamp)+ " "+results[i].timestamp)
      }*/
    }
  }
  catch(e)
  {
    console.log(e)
  }

  const [startDate, setStartDate] = useState(false);
  const [endDate, setEndDate] = useState(false);  
  const [isStartDateSelected, setIsStartDateSelected] = useState(false,);


  const handleDateChange = (val, fieldName) => {
    console.log(`handleDateChange called val ${val} fieldName ${fieldName}`) 

    const date = new Date(val)


    if(fieldName=='startdate')
    {
      
      
      setStartDate(val);
      setEndDate(false);
    }
    else
    {
      setEndDate(val)
      
    }

    let startDate1 = new Date(new Date(startDate).getFullYear() + "/" +
            ("00" + (new Date(startDate).getMonth() + 1)).slice(-2) + "/" +
            ("00" + new Date(startDate).getDate()).slice(-2) +" " +
            ("00" + new Date(startDate).getHours()).slice(-2) + ":" +
            ("00" + new Date(startDate).getMinutes()).slice(-2) + ":" +
            ("00" + new Date(startDate).getSeconds()).slice(-2)+ " UTC")
    const timestampFrom = new Date(startDate1).getTime();

    let endDate1=null;
    if(val!=null && val)
    {

        endDate1 = new Date(new Date(val).getFullYear() + "/" +
        ("00" + (new Date(val).getMonth() + 1)).slice(-2) + "/" +
        ("00" + new Date(val).getDate()).slice(-2) +" " +
        ("00" + new Date(val).getHours()).slice(-2) + ":" +
        ("00" + new Date(val).getMinutes()).slice(-2) + ":" +
        ("00" + new Date(val).getSeconds()).slice(-2)+ " UTC")
    }
    const timestampTo = val && endDate1 ? new Date(endDate1).getTime() : null;

      /*
      console.log(`@@  val ${val} endDate1 ${endDate1} `);
      setEndDate(val)
      
    }

    const 
    const 
    console.log(val)
    let date = new Date(val)
    console.log("GGGGGGGGGGGGGGGGGGGGGGGGGGGG"+val)
   let pippo = new Date(val)
    console.log(pippo.getFullYear()+"/"+pippo.getMonth()+"/"+pippo.getDay()+"T"+pippo.getHours()+":"+pippo.getMinutes()+":"+pippo.getSeconds()+"Z")
    const utcDate = new Date(pippo.getFullYear()+"/"+pippo.getMonth()+"/"+pippo.getDay()+"T"+pippo.getHours()+":"+pippo.getMinutes()+":"+pippo.getSeconds()+"Z");
    const pippo2= new Date(Date.UTC(pippo.getFullYear(),pippo.getMonth(),pippo.getDay(),pippo.getHours(),pippo.getMinutes(), pippo.getSeconds()))
console.log(pippo.getFullYear(),pippo.getMonth(),pippo.getDay(),pippo.getHours(),pippo.getMinutes(), pippo.getSeconds())
    console.log("RRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRRR"+pippo2)
    console.log("EPPPPPPPPPPPPPPPPOOOOOOOOOOOOOOOOOOOOOOOCCCCCCCCCCCCCCCCC"+pippo2.getTime())
    const dateString = startDate.toISOString().replace("T"," ").substring(0, 19);            
    const epoch = new Date(dateString).getTime();

    console.log(`startDate: ${startDate} `);
    console.log(`@@@@ startDate ${startDate}  UTC time ${dateString}  epoch ${epoch} `);
    console.log(`endDate: ${endDate} `);

    //const timestampFrom = new Date(startDate).toISO().getTime();
    //
    */
    


    console.log(`@@@ USER INPUT startDate: ${startDate} `);
    console.log(`@@@ USER INPUT endDate: ${val} `);

    if(timestampTo<timestampFrom)
    {

    }
    else
    {

        console.log(`@@@@ SEND REQUEST to API, Lambda and Dynamodb 
        startDate: ${startDate}   timestampFrom ${timestampFrom} 
        endDate: ${val}  
        timestampTo ${timestampTo}`);
  
      handleQueryInput(timestampFrom, "timestampFrom");
      handleQueryInput(timestampTo, "timestampTo");
    }

    }




  const filterEmptyKeys = (obj) => {
    const shouldKeep = (v) => (Array.isArray(v) ? v.length > 0 : v !== null);

    return Object.fromEntries(
      Object.entries(obj).filter(([_, v]) => shouldKeep(v))
    );
  };

  const handleQueryInput = (input, field) =>
    setQuery((q) => filterEmptyKeys({ ...q, [field]: input }));

  const onClick = () => {
    setEditing(false);
  };

  useDangerAlert(errorEntities || errorLanguageCodes || errorResults, setAlert);

  return (
  <ContentLayout 
    header={
      <Header
        variant="h1"
        info={<Link variant="info" ariaLabel="Info goes here.">Info</Link>}>
          Search
      </Header>
    }>
      <Container>
        <Form>
          <SpaceBetween direction="vertical" size="l">
            <FormField label="Language Code">
              <SpaceBetween direction="horizontal" size="l">
                <Select
                  onChange={(event) => handleQueryInput(event.value, "language")}
                  options={(languageCodes || []).map((code, i) => ({
                    label: code,
                    value: code,
                  }))}
                  isLoading={!languageCodes && !errorLanguageCodes}
                  value={
                    query.language
                      ? { label: query.language, value: query.language }
                      : null
                  }
                />
                <Button
                  className="mt-2"
                  variant="outline-secondary"
                  onClick={() => {
                    handleQueryInput(null, "language");
                  }}
                >
                Clear
                </Button>
              </SpaceBetween>
            </FormField>
            <FormField label="Date Range">
            <SpaceBetween direction="horizontal" size="l">    
                
              <DatePicker
              showTimeSelect
              selected={startDate}
              onChange={date => handleDateChange(date,'startdate')}
              dateFormat="dd/MM/yyyy h:mm aa"
              timeIntervals={5}
              className="calander"
              maxDate={endDate}
              placeholderText="Select a start date"/>
              <DatePicker
                showTimeSelect
                selected={endDate}
                onChange={date => handleDateChange(date,'enddate')}
                maxDate={new Date()}
                dateFormat="dd/MM/yyyy h:mm aa"
                timeIntervals={5}
                minDate={startDate}
                placeholderText="Select an end date"/>       
            </SpaceBetween>
          </FormField>
          <FormField className="warning_search"
    ><p className="warning_search">{err100text}</p></FormField>
          <FormField label="Sentiment">
            <SpaceBetween direction="horizontal" size="l">
              <p className="align-self-end mb-0">The</p>
              <Select
                className="flex-grow-1"
                options={sentimentWhat}
                onChange={(event) =>
                  handleQueryInput(event.value, "sentimentWhat")
                }
                value={
                  sentimentWhat.find((o) => o.value === query.sentimentWhat) ||
                  null
                }
              />
              <p className="align-self-end mb-0"> sentiment of the</p>
              <Select
                className="flex-grow-1"
                options={sentimentWho}
                onChange={(event) =>
                  handleQueryInput(event.value, "sentimentWho")
                }
                value={
                  sentimentWho.find((o) => o.value === query.sentimentWho) || null
                }
              />
              <p className="align-self-end mb-0">is</p>
              <Select
                className="flex-grow-1"
                options={sentimentDirection}
                onChange={(event) =>
                  handleQueryInput(event.value, "sentimentDirection")
                }
                value={
                  sentimentDirection.find(
                    (o) => o.value === query.sentimentDirection
                  ) || null
                }
              />
              <Button
                className="mt-2"
                variant="outline-secondary"
                onClick={() => {
                  handleQueryInput(null, "sentimentWhat");
                  handleQueryInput(null, "sentimentWho");
                  handleQueryInput(null, "sentimentDirection");
                }}
              >
                Clear
              </Button>
            </SpaceBetween>
          </FormField>
          <FormField label="Entities" >
            <SpaceBetween direction="horizontal" size="l">
              <MultiSelect
                options={(entities || []).map((entity) => ({
                  value: entity,
                  label: entity,
                }))}
                
                onChange={(value) => handleQueryInput(value, "entity")}
                isLoading={!entities && !errorEntities}
                />
            </SpaceBetween>
          </FormField>

          <Button bg={"primary"} onClick={onClick}>
            Search
          </Button>
            
          <hr/>
        </SpaceBetween>
      </Form>
      {!editing && (
          <ContactTable
            header={
              <Header>
              Search Results
              </Header>
            }
    
            variant="embedded"
          data={results}
          loading={!results && !errorResults}
          empty={<NoMatches />}
        />
      )}
      </Container>
    </ContentLayout>
  );
}
const NoMatches = () => (
  <div>
    <h2>No Matches</h2>
    <p>Please try a different query</p>
  </div>
);

export default Search;
